import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Preloader from '../components/Preloader';
import ScrollToTop from '../components/ScrollToTop';
import PageTitle from '../components/PageTitle';
import { WOW } from 'wowjs';
import 'animate.css';

const menuItems = [
  { img: '/images/resource/pricing2-1.png', title: 'Pasta With Fish', price: '$39', desc: 'Fresh pasta with seasonal fish', badge: 'starter' },
  { img: '/images/resource/pricing2-2.png', title: 'Noodles', price: '$16', desc: 'Asian style noodles', badge: 'new' },
  { img: '/images/resource/pricing2-3.png', title: 'Fresh Meat', price: '$26', desc: 'Premium cuts daily', badge: 'new' },
  { img: '/images/resource/pricing2-4.png', title: 'Chicken', price: '$19', desc: 'Farm-to-table chicken', badge: 'vegan' },
  { img: '/images/resource/pricing2-5.png', title: 'Spaghetti', price: '$37', desc: 'Classic Italian spaghetti', badge: 'new' },
  { img: '/images/resource/pricing2-6.png', title: 'Vegetarian Fried', price: '$34', desc: 'Healthy vegetarian option', badge: 'new' },
  { img: '/images/resource/pricing2-7.png', title: 'Vegetarian Soup', price: '$42', desc: 'Rich vegetable broth', badge: 'gluten free' },
  { img: '/images/resource/pricing2-8.png', title: 'Salmon Pasta', price: '$71', desc: 'Atlantic salmon with pasta', badge: 'fish' },
];

export default function Pricing() {
  useEffect(() => {
    const wow = new WOW({ mobile: false, live: true });
    wow.init();
  }, []);

  return (
    <div className="page-wrapper">
      <Preloader />
      <Header style="two" />
      <PageTitle title="Pricing" breadcrumbs={[{ label: 'Pages', path: '#' }, { label: 'Pricing' }]} />

      <section className="pricing-section pt-120 pb-80">
        <div className="auto-container">
          <div className="sec-title text-center wow fadeInUp">
            <span className="sub-title">Hoteler best menus</span>
            <h2>Unique Specialty Foods</h2>
          </div>
          <div className="row gx-xl-5">
            {menuItems.map((item, i) => (
              <div key={i} className="pricing-block-two col-lg-6 col-md-6 col-sm-12 wow fadeInUp" data-wow-delay={`${(i % 2) * 200}ms`}>
                <div className="inner-box">
                  <figure className="thumb overlay-anim">
                    <img src={item.img} alt={item.title} />
                  </figure>
                  <div className="content-box">
                    <h6 className="title">{item.title}<span>{item.price}</span></h6>
                    <span className="designation">{item.desc}</span>
                  </div>
                  <span className="food-pack">{item.badge}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <ScrollToTop />
    </div>
  );
}
